import HttpStatusEventBus from "../../httpStatusEventBus";
import {
  AUTH_PROCESS_FAILED,
  AUTH_SMS_VALIDATION_FAILED,
  AUTH_OTP_TOO_MANY_FAILURES,
  AUTH_IDENTITY_NOT_FOUND,
  AUTH_MOBILE_DISABLED,
  AUTH_INVALID_CREDENTIALS,
  AUTH_PASSWORD_VALIDATION_ERROR,
  AUTH_SSO_PROCESS_FAILED,
  AUTH_CAPTCHA_VALIDATION_ERROR,
  AUTH_DEVICE_VALIDATION_FAILED,
  AUTH_CHANNEL_VALIDATION_ERROR,
  AUTH_IDENTITY_VALIDATION_ERROR,
  AUTH_JWT_VALIDATION_ERROR,
  AUTH_TOTP_CODE_VALIDATION_FAILED,
  SSO_TYPE_CANNOT_BE_NULL_EXCEPTION
} from "../index";
import { eventBus } from "../../../../../plugins/event-bus";

const authErrors = [
  AUTH_PROCESS_FAILED,
  AUTH_SMS_VALIDATION_FAILED,
  AUTH_OTP_TOO_MANY_FAILURES,
  AUTH_IDENTITY_NOT_FOUND,
  AUTH_MOBILE_DISABLED,
  AUTH_INVALID_CREDENTIALS,
  AUTH_PASSWORD_VALIDATION_ERROR,
  AUTH_SSO_PROCESS_FAILED,
  AUTH_CAPTCHA_VALIDATION_ERROR,
  AUTH_DEVICE_VALIDATION_FAILED,
  AUTH_CHANNEL_VALIDATION_ERROR,
  AUTH_IDENTITY_VALIDATION_ERROR,
  AUTH_JWT_VALIDATION_ERROR,
  AUTH_TOTP_CODE_VALIDATION_FAILED,
  SSO_TYPE_CANNOT_BE_NULL_EXCEPTION
];

function isAuthError(status) {
  const error = Number(status);
  if (!error) return false;

  return authErrors.includes(error);
}

function handleAuthErrors() {
  HttpStatusEventBus.$on("AUTH_ERROR", (status) => {
    if (!isAuthError(status)) return;

    let notification_credentials = {
      i18nKey: `api_error.${status}`,
      color: "error"
    };
    eventBus.$emit("snack-bar-notification", notification_credentials);
  });
}
export default handleAuthErrors();
